import SubmissionExerciseDataService from "../axios/services/submission-exercises.service";

// The review mark says whether the correction of a submission is finished. It is stored
// with the submission, so a second corrector sees what someone else has already done.
// The local storage below is only a fallback for the moment between a click and the
// answer of the server, and for the case that the request fails.
const storageKey = (exerciseId: any) => "reviewedSubmissions:" + exerciseId;

const readLocal = (exerciseId: any) => {
  try {
    const raw = localStorage.getItem(storageKey(exerciseId));
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
};

const writeLocal = (exerciseId: any, map: any) => {
  try {
    localStorage.setItem(storageKey(exerciseId), JSON.stringify(map));
  } catch (error) {
    // Storage can be unavailable (private mode, quota); the mark then lives on the server only.
  }
};

// Built from the submissions the list has loaded anyway, so no extra request is needed.
export const getReviewedMapFromSubmissions = (exerciseId: any, submissions: any[]) => {
  const map: any = {};
  (submissions ?? []).forEach((submission: any) => {
    if (submission?.reviewCompleted === true) {
      map[submission.id] = true;
    }
  });
  writeLocal(exerciseId, map);
  return map;
};

export const getReviewedMap = (exerciseId: any) => {
  return readLocal(exerciseId);
};

export const setReviewed = async (exerciseId: any, submissionExerciseId: any, reviewed: boolean) => {
  const map = readLocal(exerciseId);
  if (reviewed) {
    map[submissionExerciseId] = true;
  } else {
    delete map[submissionExerciseId];
  }
  writeLocal(exerciseId, map);
  try {
    await SubmissionExerciseDataService.setReviewCompleted(submissionExerciseId, reviewed);
    return true;
  } catch (error) {
    // The mark is kept with the submission, so a local one that never arrived there would
    // claim a state that no one else can see. It is taken back instead.
    const rollback = readLocal(exerciseId);
    if (reviewed) {
      delete rollback[submissionExerciseId];
    } else {
      rollback[submissionExerciseId] = true;
    }
    writeLocal(exerciseId, rollback);
    return false;
  }
};

export const isReviewed = (exerciseId: any, submissionExerciseId: any) => {
  return readLocal(exerciseId)[submissionExerciseId] === true;
};
